'use client'

import { useImageUrl } from '@dustin-web/microsite-components/src/hooks/use-image-url'
import Image from '@dustin-web/microsite-components/src/image'
import { getCategoryUrl } from '@dustin-web/microsite-components/src/utils/urls'
import { useCategoryLinkByPath } from '@dustin-web/product-components/src/category-link-by-path'

export const CategoryLinkBoxes = ({ categoryPaths }: { categoryPaths: string[] }) => {
  return (
    <div className="row sm-gutters">
      {categoryPaths.map(categoryPath => {
        return <CategoryLinkBox key={categoryPath} categoryPath={categoryPath} />
      })}
    </div>
  )
}

export const CategoryLinkBox = ({ categoryPath }: { categoryPath: string }) => {
  const split = categoryPath.split('?')
  const pureCategoryPath = split[0] || ''
  const query = split[1] && `?${split[1]}`
  const { data } = useCategoryLinkByPath(pureCategoryPath)
  const { getImageUrl } = useImageUrl()

  const category = data?.categoryByPath

  if (!category) {
    return null
  }

  const mostPopularProduct = category?.mostPopularProduct?.searchResultProduct
  const displayName = mostPopularProduct?.displayName || ''

  const imageUrl = getImageUrl({
    imageFilename: mostPopularProduct?.primaryImageId,
    xSize: 160,
    ySize: 80,
    textToCreateSlugFrom: displayName,
  })

  const pureCategoryUrl = getCategoryUrl(category.pathSlug)
  const categoryUrl = query ? pureCategoryUrl + query : pureCategoryUrl

  return (
    <div className="col-12 col-sm-6 col-md-4 u-mb-16">
      <a
        className="c-box d-flex flex-column align-items-center u-decoration-none"
        href={categoryUrl}>
        {mostPopularProduct && imageUrl && (
          <Image className="u-pb-8" src={imageUrl} alt={displayName} width="160" height="80" />
        )}
        <span>{category.name}</span>
      </a>
    </div>
  )
}
